import type { TeamTag } from '@rhythmic/db/types'
import type { Transaction } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'

import { getTeamTagsCollection } from '../../getCollections'

const logger = useRhythmicLogger('useTeamContext:deleteTeamTag')

export interface DeleteTeamTagContext {
  teamId: string
}

export default function handleDeleteTeamTag(id: string, context: DeleteTeamTagContext): Transaction<TeamTag> {
  try {
    if (!id) throw new Error('Tag identifier is required')

    if (!context.teamId) throw new Error('Team context is not ready')

    const teamTagsCollection = getTeamTagsCollection(context.teamId)
    return teamTagsCollection.delete(id) as Transaction<TeamTag>
  } catch (error) {
    logger.error('deleteTeamTag failed', { id, error })
    if (error instanceof Error) throw error
    throw new Error('Failed to delete team tag')
  }
}
